import { apiPost } from "./http";

export async function submitTrialRequest(body: { orgName: string; contact: string; phone?: string }) {
  await apiPost(`/api/public/trial-requests`, body);
}

